import { RevenueReportPartnerBranchDetailPage } from "@/features/revenue-report-partner-branch/pages/RevenueReportPartnerBranchDetailPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
	"/admin/revenue-report-partner-branch/$id/detail",
)({
	validateSearch: (search: Record<string, unknown>): { tab?: string } => ({
		tab: typeof search.tab === "string" ? search.tab : undefined,
	}),
	beforeLoad({ context }) {
		if (
			!context.authAdapter.can({
				permissions: ["revenue_report_partner_branch.view"],
			})
		) {
			throw redirect({ to: "/403" });
		}
	},
	component: RevenueReportPartnerBranchDetailPage,
});
